import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { recordPageView } from "../monitoring";

/**
 * Hook that records a RUM page view on every route change.
 * Place once in the app (e.g., in App.tsx or a layout wrapper).
 */
export function useRumPageView(): void {
  const location = useLocation();

  useEffect(() => {
    // Normalize the path: replace UUIDs with :id to group page views
    const normalized = location.pathname.replace(
      /\/project\/[0-9a-f-]{36}/,
      "/project/:projectId",
    );
    recordPageView(normalized);
  }, [location.pathname]);
}
